import { render } from "./TheFooter.vue?vue&type=template&id=36fea08e&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=36fea08e&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fea08e"]])

export default __exports__